module.exports = __webpack_public_path__ + "img/GAME_PIANO.17a7be2b.jpg";